[
    {
        "name": "global_actions.update_current_user",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "global_actions.read_self_user_doc",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "global_actions.read_job_status",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "global_actions.authenticated",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "global_actions.use_password_login",
        "requires": [
            "global_spotme"
        ]
    },
    {
        "name": "org_realms.read_all_orgs",
        "requires": [
            "global_spotme"
        ]
    },
    {
        "name": "node_crud_realms.stateless_operation",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "pkg_repo_realms.read_all_packages",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "app-brandings.list_apps",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "node_crud_realms.read_event_data",
        "requires": [
            "event_viewer",
            "account_member"
        ]
    },
    {
        "name": "pkg_repo_realms.read_event_packages",
        "requires": [
            "event_viewer"
        ]
    },
    {
        "name": "node_crud_realms.create_doc",
        "requires": [
            "event_editor",
            "account_member"
        ]
    },
    {
        "name": "access_modification_realms.add_event_team_member",
        "requires": [
            "event_manager",
            "account_organizer"
        ]
    },
    {
        "name": "websockets.read_event_connections",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "user_export.allow_webapp_urls",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "node_crud_realms.modify_event_doc",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "node_crud_realms.modify_event_dates",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "pkg_repo_realms.read_available_packages",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "pkg_repo_realms.manage_event_packages",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "org_realms.list_org_workspaces",
        "requires": [
            "account_organizer"
        ]
    },
    {
        "name": "org_realms.list_org_content_hubs",
        "requires": [
            "account_organizer"
        ]
    },
    {
        "name": "org_realms.read_org_members_events",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "org_realms.read_org_members_legal_docs",
        "requires": [
            "account_member",
            "event_manager"
        ]
    },
    {
        "name": "org_realms.read_org_doc",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "pkg_repo_realms.read_org_packages",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "pkg_repo_realms.read_write_package_description",
        "requires": [
            "account_developer"
        ]
    },
    {
        "name": "pkg_repo_realms.deploy_publish_debug",
        "requires": [
            "global_developer"
        ]
    },
    {
        "name": "entitlements_realms.read_org_entitlements",
        "requires": [
            "global_spotme",
            "account_entitlement_manager"
        ]
    },
    {
        "name": "entitlements_realms.read_org_entitlements_mappings",
        "requires": [
            "global_spotme",
            "account_entitlement_manager"
        ]
    },
    {
        "name": "entitlements_realms.write_org_entitlements",
        "requires": [
            "account_entitlement_manager"
        ]
    },
    {
        "name": "entitlements_realms.settle_org_entitlements",
        "requires": [
            "global_spotme_finance"
        ]
    },
    {
        "name": "templates.get_public_template",
        "requires": [
            "account_member",
            "event_viewer"
        ]
    },
    {
        "name": "templates.get_private_template",
        "requires": [
            "event_viewer"
        ]
    },
    {
        "name": "templates.set_global_visibility",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "templates.set_category",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "templates.set_order",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "templates.create_new",
        "requires": [
            "account_organizer"
        ]
    },
    {
        "name": "global_actions.create_user",
        "requires": [
            "account_admin"
        ]
    },
    {
        "name": "org_realms.create_guest_user",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "global_actions.create_event",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "global_actions.create_production_event",
        "requires": [
            "account_api_developer",
            "account_organizer"
        ]
    },
    {
        "name": "org_realms.write_org_members_legal_docs",
        "requires": [
            "account_organizer"
        ]
    },
    {
        "name": "org_realms.write_org_workspace_default_settings",
        "requires": [
            "account_admin"
        ]
    },
    {
        "name": "org_realms.public_api",
        "requires": [
            "account_api_developer"
        ]
    },
    {
        "name": "org_realms.create_org_webhook",
        "requires": [
            "account_admin"
        ]
    },
    {
        "name": "org_realms.remove_org_member",
        "requires": [
            "account_admin"
        ]
    },
    {
        "name": "org_realms.remove_yourself_from_org",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "global_actions.can_use_webapp_magic_links",
        "requires": [
            "global_spotme_support",
            "event_manager"
        ]
    },
    {
        "name": "global_actions.can_always_see_activation_codes",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "org_realms.read_org_members_emails",
        "requires": [
            "account_admin",
            "account_api_developer"
        ]
    },
    {
        "name": "org_realms.change_workspace_duration",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "access_modification_realms.set_org_member_role",
        "requires": [
            "account_admin"
        ]
    },
    {
        "name": "global_actions.beta_tester",
        "requires": [
            "global_beta_tester"
        ]
    },
    {
        "name": "global_actions.create_org",
        "requires": [
            "global_superadmin",
            "global_spotme_csm",
            "global_spotme_am",
            "global_spotme_support"
        ]
    },
    {
        "name": "global_actions.archive_workspace",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "global_actions.toggle_role",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "global_actions.delete_user",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "websockets.read_all_connections",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "entitlements_realms.write_org_entitlements_mappings",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "pkg_repo_realms.manage_packages_repo",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "app-brandings.manage_apps",
        "requires": [
            "global_spotme"
        ]
    },
    {
        "name": "app-brandings.app_publisher",
        "requires": [
            "global_app_publisher"
        ]
    },
    {
        "name": "pkg_repo_realms.install_beta_package",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "org_realms.change_live_stream_settings",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "live_stream.manage_stream",
        "requires": [
            "account_member",
            "account_organizer",
            "event_editor"
        ]
    },
    {
        "name": "live_stream.read_qna",
        "requires": [
            "account_guest",
            "event_speaker",
            "event_viewer",
            "event_moderator",
            "event_live_display"
        ]
    },
    {
        "name": "live_stream.manage_qna",
        "requires": [
            "account_guest",
            "event_moderator"
        ]
    },
    {
        "name": "live_stream.view_details",
        "requires": [
            "account_member",
            "event_editor"
        ]
    },
    {
        "name": "live_stream.view_analytics",
        "requires": [
            "account_member",
            "event_editor"
        ]
    },
    {
        "name": "live_stream.view_connectivity_analytics",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "live_stream.view_viewers",
        "requires": [
            "account_guest",
            "event_viewer"
        ]
    },
    {
        "name": "live_stream.send_question",
        "requires": [
            "account_guest",
            "event_moderator"
        ]
    },
    {
        "name": "live_stream.manage_polls",
        "requires": [
            "account_member",
            "event_editor"
        ]
    },
    {
        "name": "live_stream.view_polls",
        "requires": [
            "account_guest",
            "event_viewer"
        ]
    },
    {
        "name": "live_stream.studio.publish_video",
        "requires": [
            "account_guest",
            "event_viewer",
            "event_speaker"
        ]
    },
    {
        "name": "live_stream.delete_any_stream",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "live_stream.studio.manage_session",
        "requires": [
            "account_member",
            "event_editor",
            "event_moderator"
        ]
    },
    {
        "name": "live_stream.studio.inspect_live_session",
        "requires": [
            "global_spotme_support",
            "global_superadmin"
        ]
    },
    {
        "name": "event_actions.show_cta",
        "requires": [
            "account_admin",
            "event_editor"
        ]
    },
    {
        "name": "event_actions.send_email",
        "requires": [
            "account_member",
            "event_manager"
        ]
    },
    {
        "name": "event_settings.view_edit_networks",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "analytics.rate_limit_bypass",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "global_actions.create_webinar",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "global_actions.create_webinar_template",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "webinar.write_template",
        "requires": [
            "account_member"
        ]
    },
    {
        "name": "global_actions.create_content_hub",
        "requires": [
            "account_organizer"
        ]
    },
    {
        "name": "global_actions.support",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "global_actions.superadmin",
        "requires": [
            "global_superadmin"
        ]
    },
    {
        "name": "global_actions.developer",
        "requires": [
            "global_developer"
        ]
    },
    {
        "name": "content_hub.read_hub",
        "requires": [
            "event_viewer"
        ]
    },
    {
        "name": "content_hub.write_hub",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "content_hub.read_content",
        "requires": [
            "event_viewer"
        ]
    },
    {
        "name": "content_hub.manage_content",
        "requires": [
            "event_editor"
        ]
    },
    {
        "name": "content_hub.manage_users",
        "requires": [
            "event_editor"
        ]
    },
    {
        "name": "content_hub.manage_design",
        "requires": [
            "event_editor"
        ]
    },
    {
        "name": "content_hub.read_analytics",
        "requires": [
            "event_manager"
        ]
    },
    {
        "name": "node_crud_realms.list_deleted_docs",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "node_crud_realms.restore_deleted_docs",
        "requires": [
            "global_spotme_support"
        ]
    },
    {
        "name": "appointments_printing.read_content",
        "requires": [
            "event_meeting_planner"
        ]
    },
    {
        "name": "appointments_printing.manage_content",
        "requires": [
            "event_meeting_planner"
        ]
    },
    {
        "name": "badge_printing.list_users",
        "requires": [
            "event_editor"
        ]
    },
    {
        "name": "badge_printing.update_users",
        "requires": [
            "event_editor"
        ]
    },
    {
        "name": "badge_printing.read_content",
        "requires": [
            "event_editor",
            "event_badge_printing_staff"
        ]
    },
    {
        "name": "badge_printing.manage_content",
        "requires": [
            "event_editor",
            "event_badge_printing_staff"
        ]
    },
    {
        "name": "badge_printing.manage_design",
        "requires": [
            "event_editor",
            "event_badge_printing_staff"
        ]
    },
    {
        "name": "leads.edit_qr_scan_api_settings",
        "requires": [
            "global_spotme"
        ]
    },
    {
        "name": "sessions.scanner",
        "requires": [
            "global_logged"
        ]
    },
    {
        "name": "customer.public_api",
        "requires": [
            "customer_api_developer"
        ]
    },
    {
        "name": "org_realms.update_org",
        "requires": [
            "global_spotme_support",
            "global_spotme_am"
        ]
    },
    {
        "name": "org_realms.update_paid_packages",
        "requires": [
            "global_spotme_am",
            "global_spotme_product"
         ]
    },
    {
        "name": "pkg_repo_realms.force_install_paid_package",
        "requires": [
            "global_spotme_support",
            "global_spotme_am"
        ]
    },
    {
        "name": "app_bstg.**",
        "requires": [
            "global_logged"
        ]
    },
    {
        "type": "group",
        "name": "_group_global_spotme_blueprint_access",
        "permissions": [
            "blueprint.module.assets-library",
            "blueprint.module.badge-design"
        ],
        "requires": [
            "global_spotme"
        ]
    },
    {
        "type": "group",
        "name": "_group_guest_core",
        "permissions": [
            "app_bstg.global.content_hubs.**",
            "app_bstg.global.welcome.**"
        ],
        "requires": [
            "account_guest"
        ]
    },
    {
        "type": "group",
        "name": "_group_granular_core",
        "permissions": [

            "app_bstg.module.background-jobs-global",
            "app_bstg.module.backstage-skeleton-global",

            "app_bstg.global.users",
            "app_bstg.global.users.changePassword",
            "app_bstg.global.users.myProfile",

            "app_bstg.core_unknown.**"
        ],
        "requires": [
            "global_logged_granular"
        ]
    },
    {
        "type": "group",
        "name": "_group_event_granular_core",
        "permissions": [
            "node_crud_realms.read_event_data",
            "websockets.read_event_connections"
        ],
        "requires": [
            "global_event_logged_granular"
        ]
    },
    {
        "type": "group",
        "name": "_group_badge_printing_staff",
        "permissions": [
            "badge_printing.**",
            "event_actions.show_cta",
            "node_crud_realms.create_doc",
            "global_actions.can_use_webapp_magic_links",

            "app_bstg.reports.badge-printing",

            "app_bstg.module.participants",
            "app_bstg.module.participants.import",
            "app_bstg.module.participants.create",
            "app_bstg.module.participants.list",
            "app_bstg.module.participants.view",
            "app_bstg.module.participants.manage_photos",

            "app_bstg.module.onsite-scanning",
            "app_bstg.module.onsite-scanning.branding",
            "app_bstg.module.onsite-scanning.kiosk",
            "app_bstg.module.onsite-scanning.printing",
            "app_bstg.module.onsite-scanning.translations",

            "blueprint.module.assets-library",
            "app_bstg.module.assets-library",
            "app_bstg.module.assets-library.details",
            "app_bstg.module.assets-library.list",

            "blueprint.module.badge-design",
            "app_bstg.module.badge-design",
            "app_bstg.module.badge-design.create",
            "app_bstg.module.badge-design.list",
            "app_bstg.module.badge-design.view",

            "app_bstg.module.dashboard.**"
        ],
        "requires": [
            "event_badge_printing_staff"
        ]
    },
    {
        "type": "group",
        "name": "_group_meeting_planner",
        "permissions": [
            "event_actions.show_cta",
            "event_actions.send_email",
            "node_crud_realms.create_doc",

            "app_bstg.reports.meetings",

            "app_bstg.module.meetings_global_sources",
            "app_bstg.module.meetings.**",
            "app_bstg.module.dashboard.**"
        ],
        "requires": [
            "event_meeting_planner"
        ]
    },
    {
        "name": "global_actions.developer",
        "requires": [
            "global_developer"
        ]
    }
]
